// @generated by protobuf-ts 2.9.4 with parameter long_type_string,generate_dependencies
// @generated from protobuf file "tts.proto" (package "speaker.beta2", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { TextToSpeech } from "./tts";
import type { ListOfVoices } from "./list_of_voices";
import type { ListOfFlavors } from "./tts";
import type { Empty } from "./google/protobuf/empty";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { SynthesizedSpeech } from "./tts";
import type { TextToSpeechRequest } from "./tts";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * *
 * This service synthesizes speech from a given text.
 *
 * @generated from protobuf service speaker.beta2.TextToSpeech
 */
export interface ITextToSpeechClient {
  /**
   * Synthesize the given text as natural language
   *
   * @generated from protobuf rpc: synthesize(speaker.beta2.TextToSpeechRequest) returns (stream speaker.beta2.SynthesizedSpeech);
   */
  synthesize(
    input: TextToSpeechRequest,
    options?: RpcOptions
  ): ServerStreamingCall<TextToSpeechRequest, SynthesizedSpeech>;
  /**
   * Enumerate all available voices
   *
   * @generated from protobuf rpc: enumerate(google.protobuf.Empty) returns (speaker.beta2.ListOfFlavors);
   */
  enumerate(
    input: Empty,
    options?: RpcOptions
  ): UnaryCall<Empty, ListOfFlavors>;
  /**
   * Enumerate all available extended voices
   *
   * @generated from protobuf rpc: enumerateVoices(google.protobuf.Empty) returns (speaker.beta2.ListOfVoices);
   */
  enumerateVoices(
    input: Empty,
    options?: RpcOptions
  ): UnaryCall<Empty, ListOfVoices>;
}
/**
 * *
 * This service synthesizes speech from a given text.
 *
 * @generated from protobuf service speaker.beta2.TextToSpeech
 */
export class TextToSpeechClient implements ITextToSpeechClient, ServiceInfo {
  typeName = TextToSpeech.typeName;
  methods = TextToSpeech.methods;
  options = TextToSpeech.options;
  constructor(private readonly _transport: RpcTransport) {}
  /**
   * Synthesize the given text as natural language
   *
   * @generated from protobuf rpc: synthesize(speaker.beta2.TextToSpeechRequest) returns (stream speaker.beta2.SynthesizedSpeech);
   */
  synthesize(
    input: TextToSpeechRequest,
    options?: RpcOptions
  ): ServerStreamingCall<TextToSpeechRequest, SynthesizedSpeech> {
    const method = this.methods[0],
      opt = this._transport.mergeOptions(options);
    return stackIntercept<TextToSpeechRequest, SynthesizedSpeech>(
      "serverStreaming",
      this._transport,
      method,
      opt,
      input
    );
  }
  /**
   * Enumerate all available voices
   *
   * @generated from protobuf rpc: enumerate(google.protobuf.Empty) returns (speaker.beta2.ListOfFlavors);
   */
  enumerate(
    input: Empty,
    options?: RpcOptions
  ): UnaryCall<Empty, ListOfFlavors> {
    const method = this.methods[1],
      opt = this._transport.mergeOptions(options);
    return stackIntercept<Empty, ListOfFlavors>(
      "unary",
      this._transport,
      method,
      opt,
      input
    );
  }
  /**
   * Enumerate all available extended voices
   *
   * @generated from protobuf rpc: enumerateVoices(google.protobuf.Empty) returns (speaker.beta2.ListOfVoices);
   */
  enumerateVoices(
    input: Empty,
    options?: RpcOptions
  ): UnaryCall<Empty, ListOfVoices> {
    const method = this.methods[2],
      opt = this._transport.mergeOptions(options);
    return stackIntercept<Empty, ListOfVoices>(
      "unary",
      this._transport,
      method,
      opt,
      input
    );
  }
}
